import { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Stack, TextField, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function StringShadingSummary({ groups, greek }) {
  const [filter, setFilter] = useState("");
  const tr = (el, en) => greek ? el : en;
  const shown = groups.filter(g => g.string_id.toLowerCase().includes(filter.toLowerCase()));
  const affected = groups.filter(g => g.worst > 0).length;
  return <Accordion disableGutters elevation={0} sx={{ border: "1px solid", borderColor: "divider", "&:before": { display: "none" } }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Stack>
        <Typography variant="subtitle2">{tr("Σκίαση ανά string / MPPT", "Shading by string / MPPT")}</Typography>
        <Typography variant="caption" color="text.secondary">{tr(
          `${groups.length} strings · ${affected} με σκίαση σε κάποια θέση ήλιου · ανάπτυξη για λεπτομέρειες`,
          `${groups.length} strings · ${affected} shaded at some sun position · expand for details`)}</Typography>
      </Stack>
    </AccordionSummary>
    <AccordionDetails>
      <Typography variant="caption" component="p" sx={{ mb: 1 }}>{tr(
        "Οι τιμές δείχνουν τη μέγιστη γεωμετρική σκίαση πλαισίου στο πλέγμα θέσεων ήλιου, όχι ετήσια απώλεια ενέργειας. Η ηλεκτρική επίδραση υπολογίζεται από τη μέθοδο σκίασης που έχετε επιλέξει.",
        "Values show maximum geometric module shading on the sun-position grid, not annual energy loss. Electrical effects use your selected shading method.")}</Typography>
      <TextField size="small" label={tr("Αναζήτηση αντιστροφέα / MPPT / string", "Find inverter / MPPT / string")}
        value={filter} onChange={e => setFilter(e.target.value)} fullWidth sx={{ my: 1 }} />
      <Box sx={{ maxHeight: 280, overflow: "auto" }}>
        {shown.map(g => <Stack key={g.string_id} direction="row" justifyContent="space-between" gap={2} sx={{ py: 0.4, borderBottom: "1px solid", borderColor: "divider" }}>
          <Typography variant="body2">{g.string_id}</Typography>
          <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>{g.modules} {tr("πλαίσια", "modules")} · {(g.worst * 100).toFixed(1)}%</Typography>
        </Stack>)}
        {!shown.length && <Typography variant="body2">{tr("Δεν βρέθηκαν strings.", "No strings found.")}</Typography>}
      </Box>
    </AccordionDetails>
  </Accordion>;
}
